import React, { useState } from 'react'
import { SelectSemesterAndYearStyles } from './Style'
import { semesterAndYearOptions } from 'keys/years'
import { semesters } from 'keys'
import { Divider } from '@mui/material'
import { LightButton } from 'styles/GlobalStyle'
import SelectOption from 'components/Form/SelectOption'

/**
 * פונקציית עזר ליצירת תווית (Label) המשלבת את שם השנה והסמסטר.
 * @param {Object} item - אובייקט המכיל את נתוני שנת הלימודים והסמסטר שנבחרו
 * @returns {string | undefined} מחרוזת מורכבת של התווית לתצוגה
 */
export const getSemesterAndYearLabel = (item) => {
    if (item?.school_year || item?.semester) {
        let strLabel = ""

        Object.keys(item).forEach(key => {
            if (item[key]?.name || item[key]?.id) {
                strLabel += ` ${item[key].name || item[key].id + " - "}`
            }
        });
        return strLabel

    }
}

/**
 * SelectSemesterAndYear Component
 * קומפוננטה המאפשרת בחירה של שנת לימודים וסמסטר.
 * הסטייט מנוהל באופן מקומי (tempValue) ומועבר החוצה רק בעת לחיצה על כפתור "החל".
 * * @param {Object} props
 * @param {Object} [props.value] - הערך ההתחלתי של הבחירה (מכיל school_year ו-semester)
 * @param {Function} props.onChange - פונקציה לעדכון הרכיב העוטף (האב) בערכים שנבחרו
 * @param {Function} props.onClose - פונקציה לסגירת תפריט הבחירה
 */
const SelectSemesterAndYear = ({ value, onChange, onClose }) => {
    const [tempValue, setTempValue] = useState(value || { school_year: null, semester: null });

    const handleSelectYear = (school_year) => {
        setTempValue(prev => ({ ...prev, school_year }));
    };

    const handleSelectSemester = (semester) => {
        setTempValue(prev => ({ ...prev, semester }));
    };

    const handleApply = () => {
        if (tempValue.school_year || tempValue.semester) {
            onChange(tempValue); // מעדכן את ה-Form הראשי
            onClose() // סוגר את התפריט
        }   
    };

    return (
        <SelectSemesterAndYearStyles
            onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <div className="title">שנת לימודים</div>
            {semesterAndYearOptions.map((year) => (
                <SelectOption
                    key={year.id}
                    option={year}
                    selected={tempValue.school_year?.id === year.id}
                    onClick={handleSelectYear}
                    getLabel={(opt) => opt.name}
                />
            ))}

            <Divider sx={{ my: 1 }} />

            <div className="title">סמסטר</div>
            {semesters.map((sem) => (
                <SelectOption
                    key={sem.id}
                    option={sem}
                    selected={tempValue.semester?.id === sem.id}
                    onClick={handleSelectSemester}
                    getLabel={(opt) => opt.name}
                />
            ))}

            <div className='applied-button'>
                <LightButton
                    size="small"
                    action={handleApply}
                    disabled={!tempValue.school_year && !tempValue.semester} // חובה לבחור את שניהם
                >
                    {"החל"}
                </LightButton>
            </div>
        </SelectSemesterAndYearStyles>
    );
};

export default SelectSemesterAndYear